import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FaCheck, FaArrowRight, FaStar } from 'react-icons/fa';
import './Pricing.css';

const plans = [
  {
    name: 'Site Vitrine',
    price: '990',
    popular: false,
    desc: 'Idéal pour présenter votre activité et être visible en ligne.',
    features: [
      'Design sur mesure responsive',
      'Jusqu\'à 5 pages',
      'Optimisation SEO de base',
      'Formulaire de contact',
      'Hébergement 1 an inclus',
      'Certificat SSL',
    ],
  },
  {
    name: 'Site E-commerce',
    price: '2 490',
    popular: true,
    desc: 'La solution complète pour vendre vos produits en ligne.',
    features: [
      'Tout du Site Vitrine',
      'Catalogue produits illimité',
      'Paiement sécurisé (CB, PayPal)',
      'Gestion des commandes',
      'Tableau de bord vendeur',
      'Formation utilisation',
    ],
  },
  {
    name: 'Application Web',
    price: '3 990',
    popular: false,
    desc: 'Application métier sur mesure pour digitaliser votre activité.',
    features: [
      'Analyse des besoins',
      'Interface sur mesure',
      'Base de données',
      'API sécurisée',
      'Panel d\'administration',
      'Support 3 mois inclus',
    ],
  },
  {
    name: 'Application Mobile',
    price: '4 990',
    popular: false,
    desc: 'Application mobile native pour Android et iOS.',
    features: [
      'Design UI/UX complet',
      'Android + iOS',
      'Notifications push',
      'Publication stores',
      'Back-end inclus',
      'Support 3 mois inclus',
    ],
  },
];

const Pricing = () => {
  return (
    <main className="page-pricing">
      <Helmet>
        <title>Tarifs Création Site Internet & Application Mobile | AGKG Créations</title>
        <meta name="description" content="Tarifs transparents pour la création de site vitrine (à partir de 990€), site e-commerce (2 490€), application web (3 990€) et application mobile (4 990€). Devis gratuit et personnalisé." />
        <link rel="canonical" href="https://agkgcreations.fr/tarifs" />
        <meta property="og:title" content="Tarifs Création Site Web & App Mobile | AGKG Créations" />
        <meta property="og:description" content="Prix transparents pour sites web et applications mobiles. Site vitrine dès 990€. Devis gratuit." />
        <meta property="og:url" content="https://agkgcreations.fr/tarifs" />
      </Helmet>

      <section className="page-hero">
        <div className="container">
          <h1 className="section-title">
            Nos <span>tarifs</span>
          </h1>
          <p className="section-subtitle">
            Des prix transparents et adaptés à chaque projet. Chaque devis est personnalisé
            selon vos besoins spécifiques.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="pricing-grid">
            {plans.map((plan, index) => (
              <div
                key={index}
                className={`pricing-card ${plan.popular ? 'pricing-popular' : ''}`}
              >
                {plan.popular && (
                  <div className="pricing-badge">
                    <FaStar /> Populaire
                  </div>
                )}
                <h3 className="pricing-name">{plan.name}</h3>
                <p className="pricing-desc">{plan.desc}</p>
                <div className="pricing-price">
                  <span className="pricing-from">à partir de</span>
                  <span className="pricing-amount">{plan.price} €</span>
                </div>
                <ul className="pricing-features">
                  {plan.features.map((feat, i) => (
                    <li key={i}>
                      <FaCheck className="pricing-check" /> {feat}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/contact"
                  className={`btn ${plan.popular ? 'btn-primary' : 'btn-secondary'} pricing-btn`}
                >
                  Demander un devis <FaArrowRight />
                </Link>
              </div>
            ))}
          </div>

          <div className="pricing-note">
            <p>
              Chaque projet est unique. Ces tarifs sont des bases indicatives.
              <strong> <Link to="/contact">Contactez-nous pour un devis personnalisé et gratuit</Link></strong> adapté
              à vos besoins exacts.
            </p>
            <div className="pricing-cross-links">
              <Link to="/services">Détail de nos services</Link>
              <span className="pricing-sep">•</span>
              <Link to="/projets">Voir nos réalisations</Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Pricing;
